(() => {
  const ROOT_SELECTOR = "[data-ha-product-notes]";

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const initProductNotes = (root) => {
    if (!root || root.dataset.haProductNotesReady === "true") return;

    const media = root.querySelector("[data-ha-product-notes-viewport]");
    const track = root.querySelector("[data-ha-product-notes-track]");
    const progress = root.querySelector("[data-ha-product-notes-progress]");
    const slides = Array.from(root.querySelectorAll("[data-ha-product-notes-slide]"));

    if (!media || !track || !slides.length) return;

    root.dataset.haProductNotesReady = "true";

    let index = 0;
    let isAnimating = false;
    let touchStartY = 0;
    let touchStartX = 0;
    let lastWheelTime = 0;

    const total = slides.length;

    const updateA11y = () => {
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
    };

    const updateProgress = () => {
      if (!progress) return;

      const scale = total <= 1 ? 1 : (index + 1) / total;
      progress.style.setProperty("--ha-product-notes-progress", String(scale));
    };

    const updateTrack = () => {
      track.style.transform = `translate3d(0, ${index * -100}%, 0)`;
      updateProgress();
      updateA11y();
    };

    const goTo = (nextIndex) => {
      const clampedIndex = clamp(nextIndex, 0, total - 1);
      if (clampedIndex === index) return false;

      index = clampedIndex;
      updateTrack();

      isAnimating = true;
      window.setTimeout(() => {
        isAnimating = false;
      }, 440);

      return true;
    };

    const goNext = () => goTo(index + 1);
    const goPrev = () => goTo(index - 1);

    const canMove = (direction) => {
      if (direction > 0) return index < total - 1;
      if (direction < 0) return index > 0;
      return false;
    };

    media.addEventListener(
      "wheel",
      (event) => {
        if (total <= 1) return;

        const deltaY = event.deltaY;
        const deltaX = event.deltaX;

        if (Math.abs(deltaX) > Math.abs(deltaY)) return;
        if (Math.abs(deltaY) < 6) return;

        const direction = deltaY > 0 ? 1 : -1;

        if (!canMove(direction)) {
          return;
        }

        event.preventDefault();

        const now = Date.now();
        if (isAnimating || now - lastWheelTime < 420) return;

        lastWheelTime = now;

        if (direction > 0) {
          goNext();
        } else {
          goPrev();
        }
      },
      { passive: false }
    );

    media.addEventListener(
      "touchstart",
      (event) => {
        if (!event.touches || !event.touches.length) return;

        touchStartY = event.touches[0].clientY;
        touchStartX = event.touches[0].clientX;
      },
      { passive: true }
    );

    media.addEventListener(
      "touchend",
      (event) => {
        if (total <= 1) return;
        if (!event.changedTouches || !event.changedTouches.length) return;

        const touchEndY = event.changedTouches[0].clientY;
        const touchEndX = event.changedTouches[0].clientX;

        const deltaY = touchStartY - touchEndY;
        const deltaX = touchStartX - touchEndX;

        if (Math.abs(deltaX) > Math.abs(deltaY)) return;
        if (Math.abs(deltaY) < 24) return;
        if (isAnimating) return;

        if (deltaY > 0) {
          goNext();
        } else {
          goPrev();
        }
      },
      { passive: true }
    );

    media.addEventListener("keydown", (event) => {
      if (total <= 1) return;

      if (event.key === "ArrowDown" || event.key === "PageDown") {
        if (canMove(1)) {
          event.preventDefault();
          goNext();
        }
      }

      if (event.key === "ArrowUp" || event.key === "PageUp") {
        if (canMove(-1)) {
          event.preventDefault();
          goPrev();
        }
      }
    });

    updateTrack();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initProductNotes);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();